module.exports = __webpack_public_path__ + "static/sensing-icon-f9f9684969cacdca3d4ef00c0fc31fe0.gif";